import SettingsAdjust16 from '@carbon/icons-react/es/settings--adjust/16';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { UserTag } from 'components/atoms/select';

export const ResponsibleFilterIcon = styled(SettingsAdjust16)`
  margin: 0 var(--spacing-03);
`;

export const ProjectFilterDropdownButton = styled(Button)`
  margin-right: var(--spacing-05);
`;

export const FilterValue = styled.strong`
  margin-left: var(--spacing-01);
`;

export const FilterTag = styled(UserTag)`
  max-width: 25ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block !important;
`;
